import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { LightSwitchState } from '../../types/court/court'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useUpdateLightSwitchState() {
  const { t } = useTranslation('exceptions')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { putter } = useFetch(
    authInfo?.accessToken,
    authInfo?.refreshToken
  )

  const updateState = async (lightSwitchName: string, enabled: boolean) => {
    setLoading(true)
    try {
      const data = await putter<LightSwitchState>(
        `${CONFIG.BOUNCE_API}/api/v1/light-switches/${encodeURIComponent(lightSwitchName)}/state`,
        { enabled },
        'application/json'
      )

      setError(null)
      return data ?? undefined
    } catch (caughtError) {
      setError(
        caughtError instanceof ApiError
          ? getErrorMessage(caughtError.data)
          : t('exceptions:unknown')
      )
      return undefined
    } finally {
      setLoading(false)
    }
  }

  const resetError = () => setError(null)

  return { updateState, loading, error, resetError }
}
